import { render, staticRenderFns } from "./LeadingPlayersGraph.vue?vue&type=template&id=4142f847&scoped=true&"
import script from "./LeadingPlayersGraph.vue?vue&type=script&lang=js&"
export * from "./LeadingPlayersGraph.vue?vue&type=script&lang=js&"
import style0 from "./LeadingPlayersGraph.vue?vue&type=style&index=0&id=4142f847&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4142f847",
  null
  
)

export default component.exports